const initialState = {
    stack: [],
    status: false,
};

export default function PreloaderReducer(state = initialState, action) {
    let parsedType = action.type.toString().match(/^(.+)_(INIT|SUCCESS|FAILURE)$/);

    if (parsedType) {
        switch (parsedType[2]) {
            case "INIT":
                state = {
                    stack: state.stack.concat([parsedType[1]]),
                }
                break;

            case "SUCCESS":
            case "FAILURE":
                state = {
                    stack: state.stack.filter(item => item !== parsedType[1]),
                }
        }

        state.status = !!state.stack.length;
    }

    return state;
}
